import * as Yup from 'yup'

import i18n from '../../../i18n'
import { getItemsIds } from '../../../utils/common'
import { getCleanValues } from '../../../utils/formHelpers'

import {
  PROVIDER_FORM_FIELD_NAME_ADDRESS,
  PROVIDER_FORM_FIELD_NAME_BUILDING,
  PROVIDER_FORM_FIELD_NAME_CATEGORY,
  PROVIDER_FORM_FIELD_NAME_DESCRIPTION,
  PROVIDER_FORM_FIELD_NAME_EMAIL,
  PROVIDER_FORM_FIELD_NAME_FILES,
  PROVIDER_FORM_FIELD_NAME_NAME,
  PROVIDER_FORM_FIELD_NAME_OPENING_HOURS,
  PROVIDER_FORM_FIELD_NAME_PHONE,
  PROVIDER_FORM_PHONE_FIELD_MAX_LENGTH,
  PROVIDER_FORM_SERVER_ERRORS,
} from './ProviderForm.constants'

export function getValidationSchema() {
  return Yup.object({
    [PROVIDER_FORM_FIELD_NAME_ADDRESS]: Yup.string(),
    [PROVIDER_FORM_FIELD_NAME_BUILDING]: Yup.array().of(Yup.object()),
    [PROVIDER_FORM_FIELD_NAME_CATEGORY]: Yup.array().of(Yup.object()),
    [PROVIDER_FORM_FIELD_NAME_DESCRIPTION]: Yup.string(),
    [PROVIDER_FORM_FIELD_NAME_EMAIL]: Yup.string()
      .required(true)
      .email(i18n.t('Error.EnterValidEmailKey')),
    [PROVIDER_FORM_FIELD_NAME_NAME]: Yup.string().trim().required(true),
    [PROVIDER_FORM_FIELD_NAME_OPENING_HOURS]: Yup.string(),
    [PROVIDER_FORM_FIELD_NAME_PHONE]: Yup.string()
      .nullable()
      .max(
        PROVIDER_FORM_PHONE_FIELD_MAX_LENGTH,
        i18n.t('Error.MaxLengthKey', {
          length: PROVIDER_FORM_PHONE_FIELD_MAX_LENGTH,
        })
      ),
  })
}

export function getPayload({ files, values }) {
  const payload = getCleanValues(values)

  if (files?.length > 0) {
    payload[PROVIDER_FORM_FIELD_NAME_FILES] = getItemsIds(files)
  }

  if (payload[PROVIDER_FORM_FIELD_NAME_BUILDING]?.length > 0) {
    payload[PROVIDER_FORM_FIELD_NAME_BUILDING] = getItemsIds(
      payload[PROVIDER_FORM_FIELD_NAME_BUILDING],
      'value'
    )
  }

  if (payload[PROVIDER_FORM_FIELD_NAME_CATEGORY]?.length > 0) {
    payload[PROVIDER_FORM_FIELD_NAME_CATEGORY] = getItemsIds(
      payload[PROVIDER_FORM_FIELD_NAME_CATEGORY],
      'value'
    )
  }

  return payload
}

export function parseProviderFormServerError(errorText, t) {
  if (PROVIDER_FORM_SERVER_ERRORS[errorText]) {
    return t(PROVIDER_FORM_SERVER_ERRORS[errorText])
  }

  return errorText
}
